const isDebug = () => {
  return process.env.REACT_APP_SERVER_ENV === 'development'
}

export { isDebug }
